<template>

  <el-dialog
    title="Редактирование сотрудника"
    :visible="visible"
    :before-close="close"
    @opened="onOpen"
  >

    <el-form ref="editForm" :rules="editFormRules" :model="editForm" v-loading="loading">
      <el-form-item label="Фамилия" prop="surname">
        <el-input name="surname" ref="autoFocus" placeholder="Введите фамилию" v-model="editForm.surname"></el-input>
      </el-form-item>
      <el-form-item label="Имя" prop="name">
        <el-input name="name" placeholder="Введите имя" v-model="editForm.name"></el-input>
      </el-form-item>
      <el-form-item label="Отчество" prop="patronymic">
        <el-input name="patronymic" placeholder="Введите отчество" v-model="editForm.patronymic"></el-input>
      </el-form-item>
      <el-form-item label="Телефон" prop="phone">
        <el-input v-mask="'+7-###-###-##-##'"
                  placeholder="+7-xxx-xxx-xx-xx"
                  auto-complete="off"
                  name="phone"
                  v-model="editForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="E-mail" prop="email">
        <el-input name="email" placeholder="Введите email адрес" v-model="editForm.email"></el-input>
      </el-form-item>
      <el-form-item label="Дата роджения" prop="birthday">
        <el-date-picker
          v-model="editForm.birthday"
          type="date"
          value-format="yyyy-MM-dd"
          format="dd.MM.yyyy"
          class="dialog__date"
          placeholder="Укажите дату рождения">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="gender_id" label="Пол">
        <el-select
          class="dialog__select"
          v-model="editForm.gender_id"
          placeholder="Укажите пол"
        >
          <el-option
            v-for="gender in genderList"
            :key="gender.id"
            :label="gender.title"
            :value="gender.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Пароль" prop="password">
        <el-input name="password" placeholder="Введите пароль" ref="password" show-password v-model="editForm.password">
          <el-tooltip content="Создать надежный пароль" slot="append">
            <el-button @click="generatePassword" icon="el-icon-magic-stick"></el-button>
          </el-tooltip>
        </el-input>
      </el-form-item>

      <!--      <el-form-item label="Роль сотрудника" prop="type">-->
      <!--        <el-select v-model="editForm.type" class="dialog__select">-->
      <!--          <el-option value="20" label="Ассистент" />-->
      <!--          <el-option value="40" label="Врач" />-->
      <!--          <el-option value="60" label="Администратор" />-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->

    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button
          name="save"
          type="primary"
          :loading="loadForm"
          @click="saveForm(true)"
        >Сохранить</el-button>
      </span>

  </el-dialog>
</template>

<script>
import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask)

export default {
  name: 'DialogWorkerEdit',
  data () {
    return {
      form: null,
      error: null,
      loadForm: !!0,
      genderList: null,
      loading: !!1,
      editForm: {},
      editFormRules: {
        surname: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        birthday: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        password: [
          { required: false, message: 'Заполните поле', trigger: 'blur' }
        ],
        phone: [
          { required: false, message: 'Заполните поле', trigger: 'blur' }
        ],
        email: [
          { validator: this.checkEmail, required: true, trigger: 'blur' },
          { type: 'email', message: 'Укажите валидный e-mail', trigger: ['blur', 'change'] }
        ],
        gender_id: [
          { required: true, message: 'Укажите пол', trigger: 'blur' }
        ],
        type: [{ required: true, message: 'Выберите роль', trigger: 'blur' }]
      }
    }
  },
  mounted () {

  },
  props: {
    worker: {
      required: true
    },
    visible: {
      required: true
    }
  },
  computed: {},
  methods: {
    onOpen () {
      this.loadLogic()
    },
    close () {
      this.$emit('close')
    },
    checkEmail (rule, value, callback) {
      if (!value) {
        return callback(new Error('Введите E-mail адрес'))
      }
      const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-z1-9-]{2,})(?:[a-z0-9-]*[a-z0-9])?/

      if (!pattern.test(String(value).toLowerCase())) {
        callback(new Error('Укажите валидный E-mail адрес'))
      } else {
        callback()
      }
    },
    loadLogic () {
      this.autoFocus()
      this.loading = !!1
      this.$api.question
        .getCompendium('gender')
        .then((response) => {
          this.genderList = response.data.data

          if (this.editForm.gender) Vue.set(this.editForm, 'gender_id', this.editForm.gender.id)
        })
        .catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        }).finally(() => {
          this.loading = !!0
        })

      this.editForm = { ...this.worker, ...this.defaultData() }
    },
    defaultData () {
      return {
        type: '20'
      }
    },
    generatePassword () {
      Vue.set(this.editForm, 'password', Math.random().toString(36).slice(-8))
      this.$refs.password.passwordVisible = !!1
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    saveForm (close) {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loadForm = !!1
          const payLoad = { ...this.editForm, ...{} }
          payLoad.phone = payLoad.phone ? payLoad.phone.replace(/[^\d]/g, '') : ''

          this.$api.doctor
            .update(payLoad.id, payLoad)
            .then(() => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные сохранены'
              })

              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.editForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadForm = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

.dialog {
  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }

  &__date {
    margin: 10px 0;
    width: 100%;
  }

  &__btns {
    float: right;
  }
}

</style>
